import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faAngleDown } from '@fortawesome/pro-light-svg-icons';

export type ProLightAngleDownProps = IconComponentProps;

export const ProLightAngleDown = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightAngleDownProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faAngleDown}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faAngleDown}
    />
  );
};

ProLightAngleDown.displayName = 'ProLightAngleDown';
